export default __webpack_public_path__ + "static/media/transfer.5ba2d90a.svg";